/* eslint-disable no-unused-vars */
/*
Format: -
{
    "type":"ContentRow",
    "contents":[
        <object>
    ]
}

Allow content objects: -
- TextInput
- StaticSelect
- ValidSelect

*/
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { TextInput } from './text-input';
import { DateInput } from './date-input';
import { NumberInput } from './number-input';

import { StaticSelect, ValidSelect } from './zeta-select';

export function ContentRow(props) {
  const { app, em, data, onChange } = props;

  // const handleDefaultClick = useCallback((e) => {});

  return (
    <div className="row mt-0 px-0">
      {em &&
        em.contents &&
        em.contents.map((t, i) => {
          const attrs = { ...props, ...t, floating: t.floating || true };
          delete attrs.app;
          delete attrs.data;
          delete attrs.onChange;

          if (typeof t.toggle === 'string' && app && app.attrs && !app.attrs[t.toggle]) {
            return null;
          }

          if (!attrs.class) {
            attrs.class = 'col-sm-4';
          }

          switch (t.type) {
            case 'TextInput':
              return <TextInput key={i} em={attrs} app={app} data={data} onChange={onChange} />;

            case 'DateInput':
              return <DateInput key={i} em={attrs} app={app} data={data} onChange={onChange} />;

            case 'NumberInput':
              return <NumberInput key={i} em={attrs} app={app} data={data} onChange={onChange} />;

            case 'StaticSelect':
              return <StaticSelect key={i} em={attrs} app={app} data={data} onChange={onChange} />;

            case 'ValidSelect':
              return <ValidSelect key={i} em={attrs} app={app} data={data} onChange={onChange} />;

            default:
              return null;
          }
        })}
      {props.children}
    </div>
  );
}
